import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { getMyProfile, getMyEndcustomers, getMyInfo } from "API/myPages";
import { MyPagesCard } from "./MyPagesCard";
import MyPageWorkflow from "./MyPageWorkflow";
import AboutClient from "Pages/AdminInterface/clients/client/clientcard/AboutClient";
import { CircularProgress } from "@mui/material";
import { useAuth } from "Hooks/useAuth";
import MyPageFortnox from "./fortnox/MyPageFortnox";

export function MyPages() {
  const [client, setClient] = useState(null);
  const { logout } = useAuth();
  const [endCustomers, setEndCustomers] = useState([]);
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const asyncInitView = async () => {
      setLoading(true);

      try {
        setClient(await getMyProfile());
        setEndCustomers(await getMyEndcustomers());
        setAboutData(await getMyInfo());
      } catch (_) {
        logout();
      } finally {
        setLoading(false);
      }
    };

    asyncInitView();
  }, []);

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Grid
          container
          rowSpacing={1}
          justifyContent="space-evenly"
          alignItems="stretch"
          columnSpacing={{ xs: 1, sm: 2, md: 1 }}
        >
          <Grid item xs={12} md={9}>
            <MyPagesCard client={client} endCustomers={endCustomers} />
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
              gap: "8px",
            }}
          >
            <AboutClient data={aboutData} clientId={client.Id} />
            <MyPageFortnox client={client} />
          </Grid>
        </Grid>
        <MyPageWorkflow endcustomers={endCustomers} client={client} />
      </Box>
    </Box>
  );
}
